import { css } from '@emotion/react';
import {
  DesignToken,
  RadiusToken,
  SpacingToken,
  ShadowToken,
} from '@livechat/design-system-react-components';
import { MEDIA_MIN_SM, MEDIA_MIN_XS } from '_assets/css/breakpoints';

export const productCardButtonStyles = ({ fullWidth }: { fullWidth: boolean }) => css`
  height: auto;
  min-width: 280px;
  max-width: 340px;
  padding: var(${SpacingToken.Spacing6});
  margin-bottom: var(${SpacingToken.Spacing1});
  align-items: start;

  cursor: pointer;
  border-radius: var(${RadiusToken.Radius3});
  border: none;
  box-shadow: var(${ShadowToken.Float});

  background-color: var(${DesignToken.SurfacePrimaryDefault});
  display: flex;
  flex-direction: column;
  white-space: normal;

  ${fullWidth &&
  css`
    ${MEDIA_MIN_SM} {
      grid-column: 1 / -1;
      max-width: unset;
    }
  `}

  &:hover {
    background-color: var(${DesignToken.SurfacePrimaryHover});
  }
`;

export const productCardContainerStyles = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(${SpacingToken.Spacing4});
`;

export const productLogoContainerStyles = css`
  min-height: 32px;
  min-width: 32px;
  max-height: 40px;
  max-width: 40px;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const mobileProductNameStyles = css`
  ${MEDIA_MIN_XS} {
    display: none;
  }
`;

export const productCopyContainerStyles = css`
  text-align: left;
`;

export const containerStyles = css`
  width: 800px;
  display: flex;
  flex-direction: column;
  gap: var(${SpacingToken.Spacing10});
  align-items: center;
  padding: 0 20px;
  height: 100%;
  justify-content: center;
`;

export const headingStyles = css`
  margin-bottom: 0;
`;

export const cardsContainerStyles = css`
  display: grid;
  grid-template-columns: 1fr;
  flex-direction: column;
  gap: var(${SpacingToken.Spacing4});

  ${MEDIA_MIN_SM} {
    grid-template-columns: 1fr 1fr;
  }
`;
